import ApplicationController from "application_controller.js";
import ahoy from "ahoy.js";

if(process.env.NODE_ENV !== "production"){
  window.ahoy = ahoy;
}

export default class extends ApplicationController {
  debug = false;

  initialize() {
    this.log_function("initialize");

    this.boundAnalyticsTrackEvent = this.onAnalyticsTrackEvent.bind(this);
    this.boundTurboLoadEvent = this.onTurboLoad.bind(this);
  }

  connect() {
    this.log_function("connect");

    ahoy.configure({
      // ? These must match the route defined within the application
      visitsUrl: `${window._tracking_path}/visits`,
      eventsUrl: `${window._tracking_path}/events`,
      trackVisits: true,
      cookies: false,
      // ? default parameters (added for reference)
      // urlPrefix: "",
      // page: null,
      // platform: "Web",
      // useBeacon: true,
      // startOnReady: true,
      // cookieDomain: null,
      // headers: {},
      // visitParams: {},
      // withCredentials: false,
      // visitDuration: 4 * 60, // 4 hours
      // visitorDuration: 2 * 365 * 24 * 60, // 2 years
    });

    window.addEventListener("ahoy_trackEvent", this.boundAnalyticsTrackEvent);
    window.addEventListener("turbo:load", this.boundTurboLoadEvent);

    this.defaultValues = {
      business: this.businessName,
      // ? The Drupal node id, which this property has always carried. Named for
      // ? what it holds so it is never read as the property's record id.
      drupal_id: parseInt(this.businessDrupalId),
      source: this.source,
      locale: this.locale,
    };
  }

  onTurboLoad(event) {
    this.log_function("onTurboLoad", event && event.detail && event.detail.url);

    ahoy.trackView(this.defaultValues);
    // ahoy.trackClicks("a, button, input[type=submit]");
    // ahoy.trackChanges("input, textarea, select");
  }

  onAnalyticsTrackEvent(event){
    this.log_function("onAnalyticsTrackEvent", event);

    if(typeof event.detail === "undefined"){
      this.log_error_function("onAnalyticsTrackEvent", "analytics", "No tracking details provided.");
      return false;
    }

    // ? saves data from event details into variable and rejects null values
    let trackEventVariables = Object.fromEntries(Object.entries(event.detail).filter(([key, value]) => value !== null));

    if(typeof trackEventVariables.type === "undefined"){
      this.log_error_function("onAnalyticsTrackEvent", "analytics", "No type value defined.");
      return false;
    }

    let eventType = trackEventVariables.type;
    delete trackEventVariables.type;

    ahoy.track(eventType, {...trackEventVariables, ...this.defaultValues});
  }

  disconnect(){
    this.log_function("disconnect");

    window.removeEventListener("ahoy_trackEvent", this.boundAnalyticsTrackEvent);
    window.removeEventListener("turbo:load", this.boundTurboLoadEvent);
  }

  get businessDrupalId() {
    const businessDrupalId = document.querySelector("meta[name='business-drupal-id']");
    return businessDrupalId ? businessDrupalId.content : "unknown";
  }

  get businessName() {
    const businessName = document.querySelector("meta[name='business-name']");
    return businessName ? businessName.content : "unknown";
  }

  get source() {
    const source = document.querySelector("meta[name='source']");
    return source ? source.content : "unknown";
  }

  get locale() {
    const locale = document.querySelector("meta[name='current-locale']");
    return locale ? locale.content : "unknown";
  }
}
